import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import Cookies from 'js-cookie';

const ProfileBookingContext = createContext({
  bookingId: null,
  projectId: null,
  lead: null,
  refreshToken: 0,
  bumpRefresh: () => {},
});

export function ProfileBookingProvider({ bookingId, projectId, lead, children }) {
  const [refreshToken, setRefreshToken] = useState(0);

  const bumpRefresh = useCallback(() => {
    setRefreshToken((token) => token + 1);
  }, []);

  const value = useMemo(
    () => ({
      bookingId: bookingId || null,
      projectId: projectId || null,
      lead: lead || null,
      refreshToken,
      bumpRefresh,
    }),
    [bookingId, projectId, lead, refreshToken, bumpRefresh],
  );

  return (
    <ProfileBookingContext.Provider value={value}>
      {children}
    </ProfileBookingContext.Provider>
  );
}

/** Prefer the active lead from Profile dashboard; fall back to cookie for legacy embeds. */
export function useProfileBookingId() {
  const ctx = useContext(ProfileBookingContext);
  if (ctx?.bookingId) return ctx.bookingId;
  return Cookies.get('bookingId') || '';
}

/** Active project UUID when viewing project detail invoices. */
export function useProfileProjectId() {
  const ctx = useContext(ProfileBookingContext);
  return ctx?.projectId || '';
}

/** Snapshot of the open pipeline lead so tabs skip extra booking fetches. */
export function useProfileLead() {
  const ctx = useContext(ProfileBookingContext);
  return ctx?.lead || null;
}

/** Bump to refetch profile tab data across History, Notes, Email, Call, etc. */
export function useProfileRefresh() {
  const ctx = useContext(ProfileBookingContext);
  return {
    refreshToken: ctx?.refreshToken ?? 0,
    bumpRefresh: ctx?.bumpRefresh ?? (() => {}),
  };
}
